import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const InventoryTable = ({ products, onAdjustStock }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'In Stock':
        return 'bg-success/10 text-success';
      case 'Low Stock':
        return 'bg-warning/10 text-warning';
      case 'Out of Stock':
        return 'bg-error/10 text-error';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Never';
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  if (!products || products?.length === 0) {
    return (
      <div className="text-center py-12">
        <Icon name="Package" size={48} className="mx-auto mb-4 text-muted-foreground" />
        <p className="text-muted-foreground">No trackable products found</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-border">
            <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">Product</th>
            <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">SKU</th>
            <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">Category</th>
            <th className="text-center py-3 px-4 text-sm font-medium text-muted-foreground">Quantity</th>
            <th className="text-center py-3 px-4 text-sm font-medium text-muted-foreground">Reorder Level</th>
            <th className="text-center py-3 px-4 text-sm font-medium text-muted-foreground">Status</th>
            <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">Last Restocked</th>
            <th className="text-center py-3 px-4 text-sm font-medium text-muted-foreground">Actions</th>
          </tr>
        </thead>
        <tbody>
          {products?.map((product) => (
            <tr key={product?.id} className="border-b border-border hover:bg-muted/50 transition-colors">
              <td className="py-3 px-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon name="Package" size={20} color="var(--color-primary)" />
                  </div>
                  <div>
                    <p className="font-medium text-foreground">{product?.name}</p>
                    <p className="text-sm text-muted-foreground">{product?.unit}</p>
                  </div>
                </div>
              </td>
              <td className="py-3 px-4">
                <span className="text-sm font-mono text-foreground">{product?.sku}</span>
              </td>
              <td className="py-3 px-4">
                <span className="text-sm text-foreground">{product?.category}</span>
              </td>
              <td className="py-3 px-4 text-center">
                <span className="text-lg font-semibold text-foreground">{product?.quantity}</span>
              </td>
              <td className="py-3 px-4 text-center">
                <span className="text-sm text-muted-foreground">{product?.reorder_level}</span>
              </td>
              <td className="py-3 px-4 text-center">
                <span className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(product?.status)}`}>
                  {product?.status === 'In Stock' && <Icon name="CheckCircle" size={14} />}
                  {product?.status === 'Low Stock' && <Icon name="AlertTriangle" size={14} />}
                  {product?.status === 'Out of Stock' && <Icon name="XCircle" size={14} />}
                  {product?.status}
                </span>
              </td>
              <td className="py-3 px-4">
                <span className="text-sm text-muted-foreground">{formatDate(product?.last_restocked)}</span>
              </td>
              <td className="py-3 px-4">
                <div className="flex items-center justify-center gap-2">
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => onAdjustStock(product)}
                  >
                    <Icon name="Edit" size={14} className="mr-1" />
                    Adjust
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InventoryTable;